import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/lib/apollo/ApolloWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/lib/datadog/rum-init.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/styles/reset.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/fonts/gotham.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/fonts/chronicle.css");
;
import(/* webpackMode: "eager" */ "/app/app/page.module.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
